"use client";

import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Building2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { loginRequest } from "@/auth/msalConfig";

interface MicrosoftLoginButtonProps {
  onClose: () => void;
  className?: string;
}

/** Uses MSAL loginPopup; only render when isMsalConfigured (inside MsalProvider). */
export function MicrosoftLoginButtonWithMsal({ onClose, className }: MicrosoftLoginButtonProps) {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogin = async () => {
    onClose();
    try {
      await instance.loginPopup(loginRequest);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error("[MSAL] loginPopup failed:", err);
    }
  };

  return (
    <Button
      variant="outline"
      className={className ?? "h-12 justify-start gap-3 text-left"}
      onClick={handleLogin}
    >
      <Building2 className="h-5 w-5 shrink-0 text-primary" />
      <span>{String(t("auth.microsoft365"))}</span>
    </Button>
  );
}
